import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProgramBuilderMainService } from '../../program-builder-main.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SuccessComponent } from 'src/app/shared/modals/success/success.component';
import { AlertComponent } from 'src/app/shared/modals/alert/alert.component';
import { getDownloadURL, getStorage, ref, uploadBytesResumable, uploadString } from 'firebase/storage';
import { HttpClient } from '@angular/common/http';
import { SharedService } from 'src/app/shared/shared.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-edit-program',
  templateUrl: './edit-program.component.html',
  styleUrls: ['./edit-program.component.scss']
})
export class EditProgramComponent implements OnInit {
	selectedFile: File | null = null;
	storage = getStorage();
	showSection: any = false;
	downloadUrl: any = ''
	categories: any = [];
	subCategories: any = [];
	unitType: any = ["Video", "Quiz", "Download"];
	categoryIndex: any;
	jsonData: any = {};
	apiCategory: any = [];
	igniteCourses: any[][] = [];
	blockLoader: string = 'blockLoader';
	vttContents: { [key: string]: string } = {};
	vttFileGenerationSub: any;
	userId: string = "";
	vttGenerationDetails: any = {
		status: "pending",
		techStatus: "",
		message: ""
	};

	constructor(
		public dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialogRef: MatDialogRef<EditProgramComponent>,
		private _programBuilderMainService: ProgramBuilderMainService,
		private spinner: NgxSpinnerService,
		private snackbar: MatSnackBar,
		private http: HttpClient,
		private sharedService: SharedService
	) {
		this.userId = localStorage.getItem("userId") ?? "";

		const vttFileObs = this._programBuilderMainService.vttFileGenObs();
		if (vttFileObs) {
			this.vttFileGenerationSub = vttFileObs.subscribe(async genDetails => {
				if (genDetails && genDetails['programId'] === this.jsonData.id) {
					// if (genDetails['message'] !== this.vttGenerationDetails.message) {
					// 	this.snackbar.open(genDetails['message'], "OK", {
					// 		duration: 3000
					// 	});
					// }
					this.vttGenerationDetails = genDetails;

					// if (genDetails['status'] === "resolved") {
					// 	await this._programBuilderMainService.clearGenerationDetails(this.userId);
					// }
				}
			});
		}
	}

  ngOnInit(): void {
    this.getCategories();
    this.getCategoriesApi();

    //Edited Data re assign.
    if (this.data) {
    //   console.log('----->Edit data', this.data);
      this.jsonData = Object.assign({}, this.data);
      if (this.jsonData.isUserEnrolled) {
        delete this.jsonData.isUserEnrolled;
      }

      if (this.jsonData.progress) {
        delete this.jsonData.progress;
      }
      this.jsonData.sections.forEach(async (section: any, index: number) => {
        this.igniteCourses[index] = [];
        let countUnits = section.numberOfUnits;
        if (countUnits > 0 && this.jsonData.sections[index].menu.length >= 1) {
          //   if (!this.jsonData.sections[index].menu.length) {
          // if(countUnits > 0){
          await this.spinner.show("blockLoader");
          for (let i = 1; i <= countUnits; i++) {
            // this.jsonData.sections[index].menu.push({
            // 	sno : `${section.sno}.${i}`,
            // 	name: '',
            // 	pts: '',
            // 	dfs: '',
            // 	type: '',
            // 	metadata: '',
            // 	downloadUrl: ''
            // });

            const menuData = this.jsonData.sections[index].menu[i - 1];
            this.changeApiCategoryType(menuData.categoryId, index, i - 1);
            this.changeIgniteCourseType(menuData.courseid, index, i - 1);
          }
          await this.spinner.hide("blockLoader");
          // }
          //   }
          // else if(this.jsonData.sections[index].menu){
          //   console.log('this.jsonData.sections[index].menu',this.jsonData.sections[index].menu);
          //   this.jsonData.sections[index].menu.forEach((item:any, menuIndex:number) => {
          //         const course = this._programBuilderMainService.getIgnite(this.jsonData.sections[index].menu[menuIndex].categoryId).subscribe(data => {
          //           console.log('data', data);
          //         })
          //         // console.log('this.jsonData.sections[index].menu[menuIndex].courseid',this.jsonData.sections[index].menu[menuIndex].courseid)
          //   })
          // }
        }
      });

	  for (let i = 0; i < this.jsonData.sections.length; i += 1) {
		let section = this.jsonData.sections[i];

		if (section.menu && section.menu.length >= 1) {
			for (let j = 0; j < section.menu.length; j += 1) {
				if (section.menu[j].metadata && section.menu[j].metadata.topics) {
					let topics = section.menu[j].metadata.topics;

					for (let t = 0; t < topics.length; t += 1) {
						let topic = topics[t];
						if (topic.vttFile) {
							this.fetchVttFile(topic.vttFile, i, t, j);
						}
					}
				}
			}
		}
	  }
    }

	// console.log(this.jsonData.id);
  }

  async onFileChange(event: any, type: string) {
    const reader = new FileReader();

    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;

      reader.readAsDataURL(file);

      reader.onload = async () => {
        const base64Response = await fetch(reader.result as string);
        // console.log(base64Response.url)
        if (type === 'programImage') this.jsonData.programImage = base64Response.url;
        else if (type === 'landscapeImage') this.jsonData.landscapeImage = base64Response.url;

      };
    }
  }

  async onDownloadFileChange(event: any, type: string, sectionIndex: any, menuIndex: any) {
    const reader = new FileReader();

    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;

      reader.readAsDataURL(file);

      reader.onload = async () => {
        const base64Response = await fetch(reader.result as string);
        // console.log(base64Response.url)
        if (type === 'portraitImage') this.jsonData.sections[sectionIndex].menu[menuIndex].metadata.documents[0].portraitImage = base64Response.url;
        else if (type === 'landscapeImage')  this.jsonData.sections[sectionIndex].menu[menuIndex].metadata.documents[0].landscapeImage = base64Response.url;



        if(this.jsonData.sections[sectionIndex].menu[menuIndex].metadata.documents[0].portraitImage.includes('data:image/png;base64,') || this.jsonData.sections[sectionIndex].menu[menuIndex].metadata.documents[0].portraitImage.includes('data:image/jpg;base64,') || this.jsonData.sections[sectionIndex].menu[menuIndex].metadata.documents[0].portraitImage.includes('data:image/jpeg;base64,')) {
          // console.log(data.programImage)
          this.jsonData.sections[sectionIndex].menu[menuIndex].metadata.documents[0].portraitImage = await this.sharedService.getUrlForUploadedFile(this.jsonData.sections[sectionIndex].menu[menuIndex].metadata.documents[0].portraitImage, `download/portrait/${this.jsonData.id}/images/image-${sectionIndex}-${menuIndex}.png`)
        }


         if(this.jsonData.sections[sectionIndex].menu[menuIndex].metadata.documents[0].landscapeImage.includes('data:image/png;base64,') || this.jsonData.sections[sectionIndex].menu[menuIndex].metadata.documents[0].landscapeImage.includes('data:image/jpg;base64,') || this.jsonData.sections[sectionIndex].menu[menuIndex].metadata.documents[0].landscapeImage.includes('data:image/jpeg;base64,')) {
          // console.log(data.programImage)
          this.jsonData.sections[sectionIndex].menu[menuIndex].metadata.documents[0].landscapeImage = await this.sharedService.getUrlForUploadedFile(this.jsonData.sections[sectionIndex].menu[menuIndex].metadata.documents[0].landscapeImage, `download/landscape/${this.jsonData.id}/images/image-${sectionIndex}-${menuIndex}.png`)
        }

      };
    }
  }

  getCategories() {
    // console.log('In organization')
    this._programBuilderMainService.getCategories().subscribe((data: any) => {
      this.categories = data;
      //   console.log(this.categories);
      this.categories.forEach(async (el: any, index: any) => {
        if (this.data) {
          if (el.id === this.data.category?.id) {
            this.categoryIndex = index;
            this.jsonData.category.name = el.name;
            this.jsonData.category.id = el.id;
            await this.getSubCategories(el.subCategories);
          }
        }
      })
    });
  }

  async getSubCategories(subCategories: any) {
    let visibleSubCat: any = [];
    await subCategories.forEach((subCat: any) => {
      if (subCat.visible) {
        visibleSubCat.push(subCat);
      }
      //   console.log(visibleSubCat);
      this.subCategories = visibleSubCat;
    })
  }

  changeCategory(ev: any) {
    // console.log(ev);
    // console.log(this.jsonData.category);
    this.subCategories = [];
    this.categories.forEach(async (el: any, index: any) => {
      if (el.id === ev) {
        this.categoryIndex = index;
        this.jsonData.category.name = el.name;
        this.jsonData.category.id = el.id;
        await this.getSubCategories(el.subCategories);
      }
    })
  }

  changeSubCategory(ev: any) {
    // console.log(ev);
    this.categories[this.categoryIndex].subCategories.forEach((el: any) => {
      if (el.id === ev) {
        this.jsonData.subCategory.name = el.name;
        this.jsonData.subCategory.id = el.id;
      }
    })
  }

  addSection() {
    let length = this.jsonData.sections.length;
    this.jsonData.sections.push({
      sno: (length + 1).toString(),
      name: '',
      description: '',
      numberOfUnits: '',
      type: 'menu',
      menu: [],
    });
    // console.log('length-----', length);
    // console.log('this.jsonData.sections-----', this.jsonData.sections.length);
    this.igniteCourses[length] = [];
  }

  addUnit(index: number) {
    let length = this.jsonData.sections[index].menu.length;
    this.jsonData.sections[index].menu.push({
      sno: `${this.jsonData.sections[index].sno}.${++length}`,
      name: '',
      pts: '',
      dfs: '',
      type: '',
      metadata: {
        documents: [{
          link: ''
        }]
      },
      downloadUrl: '',
      categoryId: '',
      courseid: ''
    });
    this.jsonData.sections[index].numberOfUnits++;
    // console.log(this.jsonData.sections[index].numberOfUnits);

  }

  removeSection(sectionIndex: number) {
	if (sectionIndex < this.jsonData.numberOfSections - 1) {
		this.jsonData.sections.splice(sectionIndex, 1);
		for (let i = sectionIndex; i < this.jsonData.sections.length; i += 1) {
			let section = this.jsonData.sections[i];

			const orgSectionNo = section.sno;
			let sectionNoSplit = orgSectionNo.split(".");
			const sectionNoFront = Number(sectionNoSplit[0]) - 1;
			let newSectionNo = [Number(sectionNoSplit[0]) - 1, ...sectionNoSplit.slice(1, sectionNoSplit.length)].join(".");
			section.sno = newSectionNo;

			for (let menuItem of section.menu) {
				const menuItemSno = menuItem.sno;
				let menuSnoSplit = menuItemSno.split(".");
				let menuNewSno = [sectionNoFront, ...menuSnoSplit.slice(1, menuSnoSplit.length)].join(".");
				menuItem.sno = menuNewSno;
			}
		}
	} else {
		this.jsonData.sections.splice(sectionIndex, 1);
	}
  }

  removeUnit(sectionIndex: number, unitIndex: number) {
    this.jsonData.sections[sectionIndex].menu.splice(unitIndex, 1);
    this.jsonData.sections[sectionIndex].numberOfUnits--;
	  const sectionNo = this.jsonData.sections[sectionIndex].sno;
	for (let i = 0; i < this.jsonData.sections[sectionIndex].menu.length; i += 1) {
		this.jsonData.sections[sectionIndex].menu[i].sno = `${sectionNo}.${Number(i + 1)}`;
	}
    // console.log(this.jsonData.sections[sectionIndex].numberOfUnits);
  }

  changeUnitType(ev: any, sectionIndex: any, menuIndex: any) {
    // console.log('changeUnitType', ev);
    // console.log('sectionIndex', sectionIndex);
    // console.log('menuIndex', menuIndex);
    // console.log(this.jsonData)
    this.igniteCourses[sectionIndex][menuIndex] = [];
    // console.log('sectionIndex', sectionIndex);
    // console.log('menuIndex', menuIndex);
    this.jsonData.sections[sectionIndex].menu[menuIndex].downloadUrl = '';
    this.jsonData.sections[sectionIndex].menu[menuIndex].type = ev;

    if (ev === 'download' || ev === 'Download') {
      this.jsonData.sections[sectionIndex].menu[menuIndex].categoryId = '';
      this.jsonData.sections[sectionIndex].menu[menuIndex].metadata = {};
      this.jsonData.sections[sectionIndex].menu[menuIndex].metadata.documents = [{
        link: ""
      }];
    }

    // console.log('igniteCourses',this.igniteCourses[sectionIndex]);
  }

  changeApiCategoryType(ev: any, sectionIndex: any, menuIndex: any) {
    // console.log('ev', ev);
    // console.log('this.igniteCourses',this.igniteCourses)
    this.jsonData.sections[sectionIndex].menu[menuIndex].categoryId = ev;
    this._programBuilderMainService.getIgnite(ev).subscribe(data => {
      //   console.log('data', data);
      if (data.success == true) {
        this.igniteCourses[sectionIndex][menuIndex] = data.courses;
      } else {
        // alert("Empty Data, Please select other option");
      }
    });
    // console.log('this.igniteCourses', this.igniteCourses);
  }

	changeIgniteCourseType(id: any, sectionIndex: number, menuIndex: number) {
		// console.log('id',id);
		// console.log(sectionIndex, '--', this.igniteCourses[sectionIndex]);
		// console.log(menuIndex);

		if (this.igniteCourses[sectionIndex].length >= 1) {
			this.igniteCourses[sectionIndex][menuIndex].forEach((course: any) => {
				// console.log(course);
			if (id === course.courseid) {
				// console.log('match');
				if (course.coverImg) {
					course.coverImg = `https://s3-ap-southeast-2.amazonaws.com/${course.coverImg}`;
					// console.log(course)
				}
				this.jsonData.sections[sectionIndex].menu[menuIndex].metadata = course;
			}
			});
		}
	}

  getCategoriesApi() {
    this._programBuilderMainService.getCategoriesApi().subscribe(data => {
      this.apiCategory = data.categories;
      //   console.log(this.apiCategory)
    })
  }

  validateFields(){
    let isValid = true;
    if(this.jsonData.numberOfSections){
      if(this.jsonData.sections.length > 0){
        for(let i = 0; i < this.jsonData.sections.length; i++){
          if(!this.jsonData.sections[i].name || !this.jsonData.sections[i].description){
            // console.log('inside 1st condition');
            this.dialog.open(SuccessComponent,{
              data:{
                title:"Oops!",
                subTitle:"Please fill all details of sections."
              },
            });
            isValid = false;
            this.spinner.hide("blockLoader");
            break;
          }else if(this.jsonData.sections[i].menu.length){
            for(let j = 0; j < this.jsonData.sections[i].menu.length; j++){
            //   console.log('this.jsonData.sections[i].menu.length',this.jsonData.sections[i].menu.length)
              if(!this.jsonData.sections[i].menu[j].name ||!this.jsonData.sections[i].menu[j].pts ||
                !this.jsonData.sections[i].menu[j].dfs){
                this.dialog.open(SuccessComponent,{
                  data:{
                    title:"Oops!",
                    subTitle:"Please fill all details of Unit."
                  },
                });
                isValid = false;
                this.spinner.hide("blockLoader");
                // console.log('inside 2st condition');
                break;
              }
            }
          }

        }
      }
    }
    // console.log('---',isValid);
    return isValid;
  }

  async saveProgram() {
    await this.spinner.show("blockLoader");
    this.jsonData.programMenuCompleted = true;
    // console.log(this.jsonData);
    this.jsonData.numberOfSections = this.jsonData.sections.length;
    let valid = this.validateFields();
    if (valid) {
      const res:any = await this._programBuilderMainService.addPrograms(this.jsonData.id, this.jsonData);
    //   console.log(res);
      await this.spinner.hide("blockLoader");
      if (res && res.status === 'success') {
        this.dialogRef.close({
          status: 'success',
          data: this.jsonData
        });
      }
    }
  }

  async deleteProgram() {
    await this.spinner.show("blockLoader");
    const dialogRef = this.dialog.open(AlertComponent, {
      data: {
        title: "Are you sure?",
        subTitle: "Do you want to delete this Program?"
      },
    });
    dialogRef.afterClosed().subscribe(async result => {
    //   console.log(`Dialog result: ${result}`);
      if (result) {
        await this.spinner.show("blockLoader");
        this._programBuilderMainService.deleteProgram(this.jsonData.id);
        await this.spinner.hide("blockLoader");
        this.dialog.open(SuccessComponent, { data: { title: "Deleted!", subTitle: "Deleted successfully." } });
      }
    });
    await this.spinner.hide("blockLoader");
    this.dialogRef.close();
  }

  getSmallCaseUnitType(unitType: string) {
    return unitType.toLowerCase();
  }

  async uploadDocument(sectionIndex: any, menuIndex: any) {
    // console.log('selectedFile', this.selectedFile)
    if (!this.selectedFile) return;

    const downloadUrl = await this._programBuilderMainService.uploadDocumentToStorage(this.selectedFile)
    // console.log('downloadUrl', downloadUrl)
    this.jsonData.sections[sectionIndex].menu[menuIndex].metadata.documents[0].link = downloadUrl
  }

  onFileSelected(event: any) {
    // console.log('event', event)
    this.selectedFile = event.target.files[0];
    // console.log('selectedFile', this.selectedFile)
  }

  onVttFileSelected(event: any, program:any, sectionIndex:any, menuIndex:any, topicIndex:any) {
    // console.log(program, sectionIndex, menuIndex, topicIndex)
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];
      if (file.name.endsWith('.vtt')) {
        const reader = new FileReader();
        reader.onload = async (e) => {
          const base64:any = (e.target as FileReader).result as string;
          this.spinner.show("blockLoader");
          // const url:any = await this._programBuilderMainService.uploadVttFile(base64, `${file.name}`, program, sectionIndex, menuIndex, topicIndex);
          this.jsonData.sections[sectionIndex].menu[menuIndex].metadata.topics[topicIndex].vttFile = base64;
          this.spinner.hide("blockLoader");
          if(base64) {
            // this.snackbar.open("Vtt file upload successfully!", "OK", {
            //   duration: 3000
            // });
            this.fetchVttFile(base64, sectionIndex, topicIndex, menuIndex);
          }else {
            this.snackbar.open("Something went wrong", "OK", {
              duration: 3000
            });
          }
        };
        reader.readAsDataURL(file);
      } else {
        this.snackbar.open("Please select a valid .vtt file.", "OK", {
          duration: 3000
        });
      }
    }
    event.target.value = null;
  }

  fetchVttFile(url: string, sectionIndex: number, topicIndex: number, menuIndex: number): void {
	if (url) {
		const compositeKey = `${sectionIndex}-${menuIndex}-${topicIndex}`;
		this.http.get(url, { responseType: 'text' }).subscribe(
		  data => this.vttContents[compositeKey] = data,
		  error => console.error('Could not load the .vtt file', error)
		);
	}
  }

	async generateVttFile(videoUrl: string, sectionIndex: number, menuIndex: number, topicIndex: number, buttonElement: any) {

		if (videoUrl && buttonElement) {
			buttonElement.disabled = true;
			buttonElement.textContent = "Generating VTT file...";

			this._programBuilderMainService.generateVttFile(videoUrl, this.jsonData.id, sectionIndex, menuIndex, topicIndex, this.jsonData).then((transcriptionRes: any) => {
				// console.log(transcriptionRes);
				if (transcriptionRes.res === "success") {
					// console.log(transcriptionRes.transcription);
					const compositeKey = `${sectionIndex}-${menuIndex}-${topicIndex}`;
					this.vttContents[compositeKey] = transcriptionRes.transcription;
				} else {
					console.log(transcriptionRes.reason);
					this.snackbar.open("Could not generate transcript. Please try again.", "OK", {
						duration: 3000
					});
				}

				buttonElement.disabled = false;
				buttonElement.textContent = "Generate VTT file";
			});
		} else {
			// console.log("Video url unavailable.");
			this.snackbar.open("Video details could not be processed. Please try again.", "OK", {
				duration: 3000
			});
		}
	}

	getVttButtonText(sectionIndex: number, menuIndex: number, topicIndex: number) {
		const genDetails = this.vttGenerationDetails;

		if (genDetails.status === "pending" && genDetails.programId === this.jsonData.id && genDetails.sectionIndex === sectionIndex && genDetails.menuIndex === menuIndex && genDetails.topicIndex === topicIndex) {
			return "Generating VTT file...";
		} else {
			return "Generate VTT File";
		}
	}

	onTextChange(event: any, topic: any) {
		const vttFileContent = event.target.value;
		const encodedVtt = btoa(vttFileContent);
		topic.vttFile = `data:text/vtt;base64,${encodedVtt}`;
	}

	ngOnDestroy() {
		this.vttFileGenerationSub.unsubscribe();
	}
}